<header
   class="header"
   role="banner"
   *ngIf="!isLogin">
   <div class="container">
      <div class="row">
         <div class="col-12 d-flex justify-content-between align-items-center">
            <div>
               <a routerLink="/">
                  <img
                     src="/assets/vetcor-white.png"
                     class="header-logo"
                     alt="VetCor"
                     style="max-height: 25px" />
               </a>
               <h1
                  *ngIf="areaName"
                  style="display: inline; vertical-align: middle; font-size: 28px">
                  {{ areaName }}
               </h1>
            </div>
            <div class="d-flex align-items-center" style="gap: 8px;">
               <button
                  class="v-button v-button-md v-translight"
                  (click)="openSuggestionEmail()"
                  aria-label="Submit suggestion">
                  Suggestion &nbsp;
                  <i
                     class="fa fa-comments"
                     aria-hidden="true"></i>
               </button>
               <button
                  class="v-button v-button-md v-translight"
                  (click)="openZohoHelpDesk()"
                  aria-label="Open Zoho help desk">
                  Help Desk &nbsp;
                  <i
                     class="fa fa-life-ring"
                     aria-hidden="true"></i>
               </button>
               <button
                  class="v-button v-button-md v-translight"
                  (click)="logOut()">
                  Logout &nbsp;
                  <i
                     class="fa fa-sign-out"
                     aria-hidden="true"></i>
               </button>
            </div>
         </div>
      </div>
   </div>
</header>
<p-breadcrumb
   *ngIf="!isLogin"
   [home]="home"
   [model]="menuItems"></p-breadcrumb>
<div class="screen-wrapper">
   <div
      *ngIf="isLoading"
      class="text-primary"
      style="color:#363636 !important; text-align: center; padding-top: 200px; font-size: 24px">
	  <img src="/assets/catSpinner.gif" style="width:130px">
      <br />
	  <br />
      Please wait...
   </div>
   <router-outlet></router-outlet>
</div>

<p-dialog
   [modal]="true"
   [(visible)]="showTimeoutModal"
   (onShow)="onTimeoutShown()">
   <ng-template #header>
      <h4
         class="modal-title mr-2"
         id="modal-basic-title">
         Keep Working?
      </h4>
   </ng-template>
   <div class="modal-body">
      {{ idleState }}
   </div>
</p-dialog>
